import clsx from "clsx";
import { keyBy } from "lodash-es";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function useStatuses() {
  const { t } = useTranslation();
  const TRANSACTION_STATUSES = useMemo(
    () => [
      {
        id: "PENDING",
        name: t("transaction_status.pending"),
        className: clsx(["bg-red-500", "text-red-50"]),
        settings: {
          color: {
            r: 255,
            g: 255,
            b: 255,
            a: 1,
          },
          bg: {
            r: 250,
            g: 15,
            b: 54,
            a: 1,
          },
        },
      },
      {
        id: "NULL",
        name: t("transaction_status.null"),
        className: clsx(["bg-gray-100", "text-gray-500"]),
        settings: {
          color: {
            r: 0,
            g: 0,
            b: 0,
            a: 1,
          },
          bg: {
            r: 75,
            g: 85,
            b: 99,
            a: 1,
          },
        },
      },
      {
        id: "PAID",
        name: t("transaction_status.paid"),
        className: clsx(["bg-green-500", "text-green-50"]),
        settings: {
          color: {
            r: 0,
            g: 0,
            b: 0,
            a: 1,
          },
          bg: {
            r: 41,
            g: 224,
            b: 15,
            a: 1,
          },
        },
      },
    ],
    [t]
  );

  const statuses = useMemo(
    () => keyBy(TRANSACTION_STATUSES, "id"),
    [TRANSACTION_STATUSES]
  );

  return {
    statuses,
  };
}
